import { Partner } from "../../services/partner";

export const state = {};

export const getters = {};

export const mutations = {};

export const actions = {
  createPartner({}, payload) {
    return Partner.create(payload);
  }
};
